module.exports = __webpack_public_path__ + "img/microsoft-logo.8ddea098.webp";